import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { IonAccordionGroup, ModalController, IonicModule } from '@ionic/angular';
import { CanteenService, IType, IAdditive, IOpenings } from '../canteen.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { add } from 'date-fns';
import { DatePipe } from '@angular/common';
import { NumberToWeekdaysPipe } from '../number-to-weekdays.pipe';

@Component({
    selector: 'app-dish-information',
    templateUrl: './dish-information.page.html',
    styleUrls: ['./dish-information.page.scss'],
    imports: [IonicModule, DatePipe, TranslatePipe, NumberToWeekdaysPipe]
})
export class DishInformationPage implements OnInit {
  private modalController = inject(ModalController);
  canteenService = inject(CanteenService);
  translateService = inject(TranslateService);

  public canteenId: string;

  public additives: IAdditive[] = [];
  public loadingAdditives: boolean = false;

  public openings: IOpenings | null = null;
  public loadingOpenings: boolean = false;
  
  public types: IType[];
  public loadingTypes: boolean = false;

  public showAllCompanyHolidays: boolean;
  public showCompanyHolidaysLimit: Date;

  @ViewChild('accordionGroup', { static: true })
  private accordionGroup!: IonAccordionGroup;


  constructor() {
    this.showAllCompanyHolidays = false;
    this.showCompanyHolidaysLimit = new Date();
    this.showCompanyHolidaysLimit.setMonth(this.showCompanyHolidaysLimit.getMonth() + 3);
  }

  ngOnInit() {
    this.loadingOpenings = true;
    this.canteenService.openings(this.canteenId).subscribe({
      next: (openings: IOpenings) => {
        this.openings = openings;
      },
      error: (_) => {
        this.loadingOpenings = false;
      },
      complete: () => {
        this.loadingOpenings = false

        if(this.accordionGroup) {
          this.accordionGroup.value = 'first';
        }
      }
    });

    this.loadingAdditives = true;
    this.canteenService.additives().subscribe({
      next: additives => {
        this.additives = additives;
        this.additives.sort((item1, item2) => {
          const number1 = +item1.id.match(/[0-9]+/gi)[0];
          const number2 = +item2.id.match(/[0-9]+/gi)[0];
          if (number1 < number2) {
            return -1;
          } else if (number2 < number1) {
            return 1;
          } else {
            const letter1 = item1.id.match(/[a-z]/gi);
            const letter2 = item2.id.match(/[a-z]/gi);
            if (letter1.length === 0 || letter2.length === 0) {
              return 0;
            } else {
              const ascii1 = letter1[0].charCodeAt(0);
              const ascii2 = letter2[0].charCodeAt(0);
              if (ascii1 < ascii2) {
                return -1;
              } else if (ascii2 < ascii1) {
                return 1;
              } else {
                return 0;
              }
            }
          }
        })
      },
      error: () => {
        this.loadingAdditives = false;
      },
      complete: () => {
        this.loadingAdditives = false;
      }
    });

    this.loadingTypes = true;
    this.canteenService.types().subscribe({
      next: (types: IType[]) => this.types = types,
      error: () => {
        this.loadingTypes = false;
      },
      complete: () => {
        this.loadingTypes = false;
      }
    });
  }

  public dismiss() {
    this.modalController.dismiss();
  }

  public isAfterLimit(holiday: { start: number, end: number }): boolean {
    return holiday.start > this.showCompanyHolidaysLimit.getTime() / 1000;
  }

  public showMoreButton(): boolean {
    return this.openings.companyHolidays.length > 1 && this.openings.companyHolidays.some((holiday: { start: number, end: number }): boolean => this.isAfterLimit(holiday))
  }

  protected readonly add = add;
}
